// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBuildingStore } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconBuildingStore
};
const marketplace: NavItemType = {
    id: 'marketplace',
    title: <FormattedMessage id="Marketplace" />,
    icon: icons.IconBuildingStore,
    type: 'group',
    url: '/marketplace',
};
// {
        //     id: 'pending-marketplace-requests',
        //     title: <FormattedMessage id="Pending Marketplace Requests" />,
        //     type: 'item',
        //     url: '/pending-marketplace-requests',
        //     target: false
        // }

export default marketplace;


